import { ALTERAR_DETALHAMENTO_ROTA } from '../types'

export default function alterarExibicaoDetalhamentoRota (rota) {
  return {
    type: ALTERAR_DETALHAMENTO_ROTA,
    payload: rota
  }
}
